import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Church } from '../../../../models/church.model';
import { IglesiasComponent } from '../iglesias.component';
import { ChurchService } from '../../../../services/church/church.service';
import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';

/*
  SE CAMBIÓ EL COMPONENTE (POR NewChurchComponent) YA QUE QUEDÓ OBSOLETO DEBIDO A QUE USABA LOS ATRIBUTOS QUE SE TENÍAN EN FIREBASE
*/

@Component({
  selector: 'app-nueva-iglesia',
  templateUrl: './nueva-iglesia.component.html',
  styleUrls: ['./nueva-iglesia.component.css']
})
export class NuevaIglesiaComponent implements OnInit {
  subiendo:boolean  = false;

  iglesia = new Church

  constructor(private _churchService: ChurchService,
              private router: Router) { }

  ngOnInit() {
  }

  crearIglesia(formNuevaIglesia:any)
  {
    this.subiendo = true;

    console.log(formNuevaIglesia);

    this._churchService.crearIglesia(this.iglesia)
      .then((data)=>{
        this.subiendo = false;

        this._churchService.iglesiaCreada = true;
        setTimeout(()=>{
          this._churchService.iglesiaCreada = false;
        },5000);

        this.router.navigate(['/admin','iglesias']);

      })
      .catch((data)=>{
        this.subiendo = false;
        console.log("Hubo un error");
      })

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/nueva-iglesia/nueva-iglesia.component.ts